import env from "../../utils/env";
 
let UsersService = function (HttpService) {
  "ngInject";
 
  const getDataSource = (successCb, errorCb) => {
    const dataSource = new kendo.data.DataSource({
      transport: {
        read: {
          url: env.getApiUrl("entities/search"),
          contentType: "application/json",
          type: "POST",
          beforeSend: _onBeforeSend,
        },
        parameterMap: _parameterMap
      },
      change: successCb,
      schema: {
        data: "data",
        total: "total"
      },
      error: errorCb,
      serverFiltering: true,
      serverPaging: true,
      serverSorting: true,
      pageSize: 50
    })
 
    return dataSource;
  }
 
  const getUserDetails = (userId, successCb, failureCb) => {
    HttpService.get(`entities/${userId}`, successCb, failureCb);
  }

   const getPayAgreements = (userId, successCb, failureCb) => {
    HttpService.get(`entities/${userId}/payagreements`, successCb, failureCb);
  };
 
  const resetPayto = (userId, payAgreementId, successCb, failureCb) => {
    HttpService.deleteResource(`entities/${userId}/payagreements/${payAgreementId}`, successCb, failureCb);
  };
 
  // Not supported.
  const updateUserDetails = (userId, payload, successCb, failureCb) => {
    HttpService.patch(`entities/${userId}`, payload, successCb, failureCb);
  }
 
  const cancelSubscription = (userId, payload, successCb, failureCb) => {
    HttpService.patch(`entities/${userId}/cancelsubscription`, payload, successCb, failureCb);
  }
 
  const refundInvoice = (invoiceId, payload, successCb, failureCb) => {
    HttpService.patch(`entities/refundinvoice/${invoiceId}`, payload, successCb, failureCb);
  }
 
  const getLoginAsUserAccessToken = (userId, successCb, failureCb) => {
    HttpService.get(`tokens/${userId}`, successCb, failureCb);
  }
 
  const deleteUser = (userId, successCb, failureCb) => {
    HttpService.deleteResource(`entities/${userId}`, successCb, failureCb);
  }
 
  const disableAccount = (userId, successCb, failureCb) => {
    HttpService.patch(`entities/${userId}/disableaccount`, {}, successCb, failureCb);
  }
 
  const reactivateAccount = (userId, successCb, failureCb) => {
    HttpService.patch(`entities/${userId}/reactivateaccount`, {}, successCb, failureCb);
  }
 
  const updateWalletBalance = (userId, walletBalance, successCb, failureCb) => {
    const payload = {
      userId: userId,
      walletBalance: walletBalance,
    };
    HttpService.patch(`entities/${userId}/updatewalletbalance`, payload, successCb, failureCb);
  }
 
  const updateJobPostLimit = (userId, increaseBy, successCb, failureCb) => {
    HttpService.patch(`entities/${userId}/updatejobpostlimit`, { increaseBy: parseInt(increaseBy) }, successCb, failureCb);
  }
 
  // Not supported.
  const resetPassword = (userId, payload, successCb, failureCb) => {
    HttpService.post(`bigfoot/users/changepassword/${userId}`, payload, successCb, failureCb);
  }
 
  const getRatingsDataSource = (userId, isClient) => {
    const dataSource = new kendo.data.DataSource({
      transport: {
        read: {
          url: env.getApiUrl(`entities/${userId}/ratings?isClient=${isClient}`),
          contentType: "application/json",
          type: "GET",
          beforeSend: _onBeforeSend,
        },
        update: {
          url: (item) => env.getApiUrl(`entities/${userId}/ratings/${item.id}?isClient=${isClient}`),
          contentType: "application/json",
          type: "PATCH",
          beforeSend: _onBeforeSend,
        },
        parameterMap: (data, type) => {
          if (type === "update") {
            return JSON.stringify({
              category1: data.category1,
              category2: data.category2,
              category3: data.category3,
              category4: data.category4,

            });
          }
        }
      },
      schema: {
        model: {
          id: "id",
          fields: {
            id:         { editable: false },
            ratingById: { editable: false },
            firstName:  { editable: false },
            lastName:   { editable: false },
            category1:  { type: "number", validation: { min: 0, max: 5 } },
            category2:  { type: "number", validation: { min: 0, max: 5 } },
            category3:  { type: "number", validation: { min: 0, max: 5 } },
            category4:  { type: "number", validation: { min: 0, max: 5 } },
            ratingSum:  { editable: false },
            ratingAvg:  { editable: false },
            feedback:   { editable: false },
            jobId:      { editable: false },
            ratingDate: { editable: false },
          }
        }
      },
      serverFiltering: false,
      serverPaging: false,
      serverSorting: false,
      pageSize: 50
    });
 
    return dataSource;
  }
 
  const getMessagesDataSource = (userId, convertToLocalTime, successCb) => {
    const dataSource = new kendo.data.DataSource({
      transport: {
        read: {
          url: env.getApiUrl(`entities/${userId}/messages/${convertToLocalTime}`),
          contentType: "application/json",
          type: "GET",
          beforeSend: _onBeforeSend,
 
        },
      },
      change: successCb,
      serverFiltering: false,
      serverPaging: false,
      serverSorting: false,
 
 
      pageSize: 50
    })
 
    return dataSource;
  }
 
  return {
    getDataSource,
    getUserDetails,
    updateUserDetails,

    cancelSubscription,
    refundInvoice,
    getLoginAsUserAccessToken,
    deleteUser,
    disableAccount,
    updateWalletBalance,
    updateJobPostLimit,
    reactivateAccount,
    resetPassword,
    getMessagesDataSource,
    getRatingsDataSource,
    getPayAgreements,
    resetPayto,
  };
}
 
function _onBeforeSend(req) {
  var token = `Bearer ${window.localStorage.getItem("bigfootAccessToken")}`;
 
  req.setRequestHeader("Authorization", token);
}
 
function _parameterMap(data, type) {
  let filters = [];
 
  if(data.filter) filters = data.filter.filters;
 
  let query = Object.assign({}, { filters: filters }, data)
  delete query.filter;
 
  console.log("Query::", query)
 
  return JSON.stringify(query);
}
 
export default UsersService;


/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/services/users.service.js
 **/